import {IconNames} from '@atoms';
import {CancellableWorkdayStatus} from '@lib/store/src/data/timeslots/apiTypes';

export const getWorkdayStatusIconName = (type: CancellableWorkdayStatus | undefined): IconNames => {
  switch (type) {
    case 'OfficeDay':
      return 'office';
    case 'WorkingRemotely':
      return 'remote';
    case 'NotWorking':
      return 'calendarX';
    case 'Unknown':
    default:
      return 'locationUnknown';
  }
};
